import React from 'react';
import Years1Icon from '@material-ui/icons/Filter1';
import Years2Icon from '@material-ui/icons/Filter2';
import Years3Icon from '@material-ui/icons/Filter3';
import Years4Icon from '@material-ui/icons/Filter4';
import { Box, Typography, Tooltip, Popover } from '@material-ui/core';
import OwnershipIcon from '@material-ui/icons/AccountBalance';
import RuralIcon from '@material-ui/icons/House';
import SuburbanIcon from '@material-ui/icons/HomeWork';
import CityIcon from '@material-ui/icons/LocationCity';
import TownIcon from '@material-ui/icons/EmojiTransportation';
import PeopleIcon from '@material-ui/icons/People';
import { makeStyles } from '@material-ui/core/styles';
import maxBy from 'lodash/maxBy';
import minBy from 'lodash/minBy';
import { schoolSizes} from '../constants';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  thumb: {
    width: 100,
  },
  icon: {
    color: theme.palette.text.secondary,
    marginRight: theme.spacing(1),
    fontSize: 16,
  },
}));

const getYearIcon = (year, classes) => (
  <Box display="flex" alignItems="center">
    {(year === 4 && <Years4Icon className={classes.icon} />) ||
      (year === 1 && <Years1Icon className={classes.icon} />) ||
      (year === 3 && <Years3Icon className={classes.icon} />) ||
      (year === 2 && <Years2Icon className={classes.icon} />) ||
      (!year && <Typography variant="caption">N/A</Typography>)}
    <Typography variant="caption">{year > 1 ? 'Years' : 'Year'}</Typography>
  </Box>
);

const getOwnershipIcon = (value, classes) => (
  <Box display="flex" alignItems="center">
    <OwnershipIcon className={classes.icon} />
    <Typography variant="caption">
      {value === 1 ? 'Public' : 'Private'}
    </Typography>
  </Box>
);

const getLocaleIcon = (locale, classes) => (
  <Box display="flex" alignItems="center">
    {(locale > 40 && <RuralIcon className={classes.icon} />) ||
      (locale > 30 && <TownIcon className={classes.icon} />) ||
      (locale > 20 && <SuburbanIcon className={classes.icon} />) ||
      (locale > 10 && <CityIcon className={classes.icon} />) ||
      (!locale && <Typography variant="caption">N/A</Typography>)}
    <Typography variant="caption">
      {(locale > 40 && 'Rural') ||
        (locale > 30 && 'Town') ||
        (locale > 20 && 'Suburban') ||
        (locale > 10 && 'City')}
    </Typography>
  </Box>
);

const getSize = (value, classes) => (
  <Box display="flex" alignItems="center">
    <PeopleIcon className={classes.icon} />
    <Typography variant="caption">
      {
        (value >= schoolSizes.large && 'Large') ||
        (value >= schoolSizes.medium && 'Medium') ||
        (value >= schoolSizes.small && 'Small') ||
        'N/A'}
    </Typography>
  </Box>
);

const Summary = ({ school }) => {
  const classes = useStyles();

  const earningsData =
    school['latest.programs.cip_4_digit']?.length > 1
      ? [
          minBy(
            school['latest.programs.cip_4_digit'],
            'earnings.median_earnings',
          )?.earnings?.median_earnings,
          maxBy(
            school['latest.programs.cip_4_digit'],
            'earnings.median_earnings',
          )?.earnings?.median_earnings,
        ]
      : null;

  const marks = earningsData && [
    {
      value: earningsData[0],
      label: earningsData[0] ? `$${earningsData[0]?.toLocaleString()}` : 'N/A',
    },
    {
      value: earningsData[1],
      label: earningsData[1] ? `$${earningsData[1]?.toLocaleString()}` : 'N/A',
    },
  ];

  return (
    <Box display="flex" justifyContent="space-between" marginBottom={3}>
      {school &&
      getYearIcon(school['school.degrees_awarded.highest'], classes)}
      {school && getOwnershipIcon(school['school.ownership'], classes)}
      {school && getLocaleIcon(school['school.locale'], classes)}
      {school && getSize(school['latest.student.size'], classes)}
    </Box>
  );
};

export default Summary;
